// src/googleAds.ts
declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: any[]) => void;
  }
}

/**
 * Fires Google Ads conversion event on CTA click.
 * If you pass redirectUrl, it will redirect after callback.
 */
export function reportAdsConversion(params?: {
  redirectUrl?: string;
  value?: number;
  currency?: string;
  onDone?: () => void; // for SPA navigation (react-router / next router)
}): boolean {
  const { redirectUrl, value = 1.0, currency = "USD", onDone } = params || {};

  // If gtag isn't ready, don't block user action.
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    if (onDone) onDone();
    else if (redirectUrl) window.location.href = redirectUrl;
    return true;
  }

  const callback = () => {
    if (onDone) onDone();
    else if (redirectUrl) window.location.href = redirectUrl;
  };

  window.gtag("event", "conversion", {
    send_to: "AW-792184678/v5YACO--k_UZEOaO3_kC",
    value,
    currency,
    event_callback: callback,
  });

  // Optional: fallback in case callback doesn't fire (adblock/network)
  window.setTimeout(callback, 1200);

  // Returning false is useful when you want to prevent default navigation
  // and let the callback handle redirect.
  return false;
}
